import { localisePrice } from '#lib/locale'
import pluck from 'ramda/src/pluck'
import { localeToCurrencyMap } from '#src/common/constants'

export const getCumulativePrice = (productPrice, groupOptions, locale) => {
  const options = groupOptions.reduce((acc, curr) => {
    acc = [...acc, ...curr.options]
    return acc
  }, [])

  const cumulativeCentAmount = [
    productPrice,
    ...pluck(
      'price',
      options.filter(item => item.isSelected)
    )
  ].reduce((acc, obj) => {
    return acc + (obj?.centAmount || 0)
  }, 0)

  const cumulativePrice = {
    fractionDigits: productPrice?.fractionDigits || 2,
    centAmount: cumulativeCentAmount * 1,
    currencyCode: localeToCurrencyMap[locale]
  }
  return localisePrice(cumulativePrice, locale)
}

export const productUnavailabilityRedirectUrl = (settings, locale) => {
  const {
    productUnavailable: { slug: productUnavailableSlug }
  } = settings

  const productUnavailablePath = `/${locale}/${productUnavailableSlug}`
  const fallbackRedirectPath = `/${locale}/products`
  return productUnavailableSlug ? productUnavailablePath : fallbackRedirectPath
}

export const productUnAvailabilityRedirectPath = ({
  product,
  locale,
  settings
}) => {
  if (!product) {
    return { notFound: true }
  } else if (product.visibleInMenu === false) {
    return {
      redirect: {
        destination: productUnavailabilityRedirectUrl(settings, locale),
        permanent: false
      }
    }
  }
}
